const state = {
    restTime: false,
    campaignTime: true,
    startCampaign: false,
    inCall: false,
    callData: {
        tab: null,
        tab_obs: null,
        call_id: null,
        scheduling_datetime: null,
        schedule_date: null,
        reason: null,
        tab_reason_id: null,
        user_id: null,
        user_name: null,
        user_phone: null,
        scheduled_to: null,
        scheduled_name: null,
        extension_scheduled: null,
    }
}

const getters = {
    getRestTime: state => state.restTime,
    getCampaignTime: state => state.campaignTime,
    getStartCampaign: state => state.startCampaign,
    getCallData: state => state.callData,
    getInCall: state => state.inCall,
}

const mutations = {
    mutationRestTime: (state, data) => {
        const tempValue = data == null ? !state.restTime : !!data;
        state.restTime = tempValue;
        state.campaignTime = !tempValue;
    },
    mutationCampaignTime: (state, data) => {
        const tempValue = data == null ? !state.campaignTime : !!data;
        state.campaignTime = tempValue;
        state.restTime = !tempValue;
    },
    mutationStartCampaign: (state) => {
        state.startCampaign = !state.startCampaign;
    },
    mutationCallData: (state, data) => {
        if (data.tab) state.callData.tab = data.tab;
        if (data.tab_obs) state.callData.tab_obs = data.tab_obs;
        if (data.call_id) state.callData.call_id = data.call_id;
        if (data.scheduling_datetime) state.callData.scheduling_datetime = data.scheduling_datetime;
        if (data.schedule_date) state.callData.schedule_date = data.schedule_date;
        if (data.reason) state.callData.reason = data.reason;
        if (data.tab_reason_id) state.callData.tab_reason_id = data.tab_reason_id;
        if (data.user_id) state.callData.user_id = data.user_id;
        if (data.user_name) state.callData.user_name = data.user_name;
        if (data.user_phone) state.callData.user_phone = data.user_phone;
        if (data.scheduled_to) state.callData.scheduled_to = data.scheduled_to;
        if (data.scheduled_name) state.callData.scheduled_name = data.scheduled_name;
        if (data.extension_scheduled) state.callData.extension_scheduled = data.extension_scheduled;
    },
    mutationInCall: (state, data) => {
        state.inCall = data;
    }
}

const actions = {
    async setRestTime({ commit }, data = null) {
        commit('mutationRestTime', data);
    },
    async setCampaignTime({ commit }, data = null) {
        commit('mutationCampaignTime', data);
    },
    async setStartCampaign({ commit }) {
        commit('mutationStartCampaign');
    },
    async setCallData({ commit }, data) {
        commit('mutationCallData', data);
    },
    async setInCall({ commit }, data) {
        commit('mutationInCall', data);
    }
}

export default {
    getters,
    mutations,
    actions,
    state
}